/**
 * @generated SignedSource<<d1bf5eca7b0eed69042769b107764580>>
 * @relayHash 247cded13ba83a21ff6138efd328a2d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 423e945007cc3bde612f3dab2e0db0de3d712ae9e38a626a45bdd369cc45610e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isUsePlatformUimCoreInJiraEnabled_provider from '@atlassian/jira-relay-provider/src/ditt-uim-use-platform-uim-core-in-jira.relayprovider';
import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import includeEgressOverridesForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-egress-overrides.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "423e945007cc3bde612f3dab2e0db0de3d712ae9e38a626a45bdd369cc45610e",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeegressoverridesrelayprovider": includeEgressOverridesForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcdittuimuseplatformuimcoreinjirarelayprovider": isUsePlatformUimCoreInJiraEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
